// @flow

import * as React from 'react'
import NumericInput from './numeric-input'
import Icon from './icon'

type Props = {
  onChange: number => void,
  value: number,
  min: number,
  max: number,
}

type State = {
  value: number,
}

export default class extends React.Component<Props, State> {
  handleInc: () => void
  handleDec: () => void
  handleChange: (SyntheticInputEvent<HTMLInputElement>) => void
  myInput: any

  static defaultProps = {
    max: 999999999999999,
    min: -999999999999999,
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      value: this.props.value,
    }
    this.handleInc = this.handleInc.bind(this)
    this.handleDec = this.handleDec.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e: SyntheticInputEvent<HTMLInputElement>) {
    let {value} = e.currentTarget
    value = parseInt(value)
    if (isNaN(value)) {
      e.preventDefault()
      return
    } else {
      this.props.onChange(value)
    }
  }

  handleInc() {
    const {onChange, value, max} = this.props
    onChange(value + 1 >= max ? max : value + 1)
  }

  handleDec() {
    const {onChange, value, min} = this.props
    onChange(value - 1 > min ? value - 1 : min)
  }

  render() {
    const {value, ...otherProps} = this.props
    return (
      <div className="numeric-step-input">
        <button className="numeric-step-input-button" onClick={this.handleDec}>
          <Icon name="icon-minus" />
        </button>
        <NumericInput
          {...otherProps}
          className="numeric-step-input-input"
          value={value}
          onChange={this.handleChange}
        />
        <button className="numeric-step-input-button" onClick={this.handleInc}>
          <Icon name="icon-plus" />
        </button>
      </div>
    )
  }
}
